import React, {useEffect, useState} from "react";
import {errorMessage, post} from "./api2026";

// games played and partners of the player, read from the Nostra sessions
export const MyParties2026 = () => {

    const [data, setData] = useState(undefined);
    const [error, setError] = useState("");

    useEffect(() => {
        post("/nostra/me").then(setData).catch(err => setError(errorMessage(err)));
    }, []);

    if (error) {
        return <div className="anniv2026-parties-empty">{error}</div>;
    }
    if (!data) {
        return <div className="anniv2026-parties-empty">Chargement de tes parties...</div>;
    }
    if (data.parties === 0) {
        return <div className="anniv2026-parties-empty">Aucune partie jouée pour l'instant.</div>;
    }

    return (
        <div>
            <h3>Mes jeux joués <span className="anniv2026-h3-count">{data.parties} {data.parties > 1 ? "parties" : "partie"}</span></h3>
            <div className="anniv2026-carousel">
                {
                    data.games.map(game =>
                        <div key={game.id || game.name} className="anniv2026-card anniv2026-carousel-item">
                            {
                                game.logo ?
                                    <img src={game.logo} alt={game.name}/> :
                                    <div className="anniv2026-game-placeholder">{game.name}</div>
                            }
                            <div className="anniv2026-game-author">{game.name}</div>
                            <div className="anniv2026-game-votes">{game.count} {game.count > 1 ? "parties" : "partie"}</div>
                        </div>
                    )
                }
            </div>

            <h3>Mes partenaires de jeu <span className="anniv2026-h3-count">{data.partners.length}</span></h3>
            <div className="anniv2026-carousel">
                {
                    data.partners.map(partner =>
                        <div key={partner.name} className="anniv2026-card anniv2026-partner">
                            <div className="anniv2026-partner-avatar">{partner.name.charAt(0).toUpperCase()}</div>
                            <div className="anniv2026-partner-name">{partner.name}</div>
                            <div className="anniv2026-game-votes">{partner.count} {partner.count > 1 ? "parties" : "partie"}</div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
